export enum InputContextType {
  // TODO: WIOT-1310 the strings have to be capitalized and the classNames have to be adapted, in all the less files
  MODAL = 'modal',
  FILTER_BAR = 'filter-bar',
}
